<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>For my father, Waldo Everett Nunez, who stayed, and for my mother, Una Magdalen Arneaud Nunez, whom he loves</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?184a9aa8